@if (isStandardView) {
  <div id="itemContainer" class="item-container" #itemContainer [@comeUp]>
    @if ((data && unfilteredData.length !== 0) || !data) {
      @for (item of unfilteredData; track item) {
        <app-admin-hyperlink-item (click)="goToHyperlink(item)" [item]="item" [index]="$index" [style.height.px]="itemWidth" />
      }
    } @else {
      <div class="no-data-container">
        <fa-icon [icon]="['fas', 'baby']" size="2x"></fa-icon>
        <span>{{ "default.buttons.noData" | translate }}</span>
      </div>
    }
  </div>
}
@if (isInfoView) {
  <app-admin-hyperlink-info />
}
@if (isEditView) {
  <app-admin-hyperlink-edit />
}
@if (isCreateView) {
  <app-admin-hyperlink-create />
}
